<template>
  <div class="shop-steps">
    <button
      class="shop-steps__item"
      :data-id="item.id"
      v-for="(item, index) in itemsComp"
      :key="index"
      :class="[
        {
          'shop-steps__item--active-before': (itemsComp[index + 1] || {}).id === value,
          'shop-steps__item--active': item.id === value,
          'shop-steps__item--active-after': (itemsComp[index - 1] || {}).id === value,
        },
        'shop-steps__item--status-' + item.status,
      ]"
      @click="() => $emit('input', item.id)"
    >
      <span data-part="icon">
        {{ index + 1 }}
      </span>
      <span data-part="label">{{ item.label }}</span>
    </button>
  </div>
</template>

<script>
import Icon from '@kvass/vue2-icon'

export default {
  props: {
    value: String,
    items: Array,
    summary: Boolean,
    sets: Boolean,
  },
  watch: {
    value: {
      handler(val) {
        this.$nextTick(() => this.$el.scrollIntoView({ behavior: 'smooth', inline: 'start' }))
      },
      immediate: true,
    },
  },
  computed: {
    itemsComp() {
      const items = [
        { id: 'intro', label: this.$t('startpage') },
        ...this.items,
        { id: 'summary', label: this.$t('shopSummary') },
      ]

      if (this.sets) items.splice(1, 0, { id: 'sets', label: this.$tc('shopSet', 2) })

      return items
    },
  },
  components: {
    Icon,
  },
}
</script>

<style lang="scss">
.shop-steps {
  z-index: 2;
  position: relative;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  white-space: nowrap;
  overflow-x: auto;

  &__item {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;

    text-align: left;
    white-space: nowrap;

    color: inherit;

    cursor: pointer;

    padding-block: 0.5rem;
    padding-inline: 0.6rem 1.25rem;

    transition-property: background-color opacity color border-color;
    transition-duration: 100ms;
    transition-timing-function: ease-out;

    border: 1px solid transparent;

    border-radius: 50px;

    opacity: 0.7;

    [data-part='icon'] {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      line-height: 0;

      border: 1px solid var(--border-color);
      border-radius: 50%;
      font-size: 0.8em;

      width: 23px;
      height: 23px;

      transition-property: inherit;
      transition-duration: inherit;
      transition-timing-function: inherit;
    }

    &--active {
      color: var(--shop-text-color);
      background-color: white;
      border-color: var(--border-color);

      [data-part='icon'] {
        background-color: var(--primary);
        color: white;
        border-color: var(--primary);
      }
    }

    &:hover:not(&--active) {
      border-color: var(--border-color);

      [data-part='icon'] {
        border-color: hsl(
          var(--border-color-h),
          var(--border-color-s),
          calc(var(--border-color-l) + 2%)
        );
        background-color: hsl(
          var(--border-color-h),
          var(--border-color-s),
          calc(var(--border-color-l) + 2%)
        );
      }
    }

    &:is(&--active, :hover) {
      opacity: 1;
    }

    &--status-expired {
      [data-part='icon'] {
        border-color: hsl(var(--error-h), var(--error-s), 80%) !important;
        background-color: hsl(var(--error-h), var(--error-s), 95%) !important;
        color: var(--error) !important;
        font-weight: bold;
      }
    }

    &--status-signed,
    &--status-accepted {
      [data-part='icon'] {
        border-color: hsl(var(--success-h), var(--success-s), 90%) !important;
        background-color: hsl(var(--success-h), var(--success-s), 90%) !important;
        color: hsl(var(--success-h), var(--success-s), 10%) !important;
        font-weight: bold;
      }
    }
  }
}
</style>
